import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { KatDropdown } from '@amzn/katal-react';
import { AuthContext, IAuthContext } from 'src/state/providers/AuthProvider';
import { ResourceAttributes } from 'src/state/slice/models/CaseLifecycleTypes';
import {
  LocalStorageKeys,
  getLocalStorageItem,
  setLocalStorageItem,
} from 'src/utilities/LocalStorage';
const AccountPickerContainer = styled.div`
  width: 12rem;
  kat-dropdown {
    --font-size: ${({ theme }) => theme.fontSize.m};
    --border-radius: 0.2rem;
  }
`;

const SingleAccountContainer = styled.div`
  color: ${({ theme }) => theme.colors.White};
  font-size: ${({ theme }) => theme.fontSize.m};
`;

export interface DropDownOptions {
  name: string;
  value: string;
}

export function getAccountDropdownOptions(
  accountAttributes: ResourceAttributes[],
): DropDownOptions[] {
  if (!accountAttributes || accountAttributes.length == 0) {
    return [];
  }

  return accountAttributes?.map((accountAttribute) => {
    return {
      name: accountAttribute?.attributes?.accountName,
      value: accountAttribute?.id,
    };
  });
}

export function getPreSelectedAccountId(userContext: IAuthContext): string {
  const accountIdFromStorage = getLocalStorageItem(
    LocalStorageKeys.SELECTED_ACCOUNT,
  );
  return accountIdFromStorage
    ? accountIdFromStorage
    : userContext.preferredAccountId;
}

const AccountPicker = () => {
  const userContext: IAuthContext = useContext(AuthContext);

  if (userContext?.accountAttributes?.length === 0) {
    return null;
  }

  const [selectedAccountId, setSelectedAccountId] = useState(
    getPreSelectedAccountId(userContext),
  );
  let accountDropdownItems = getAccountDropdownOptions(
    userContext.accountAttributes,
  );

  useEffect(() => {
    if (selectedAccountId != userContext.preferredAccountId) {
      userContext.setPreferredAccountId(selectedAccountId);
      setLocalStorageItem(LocalStorageKeys.SELECTED_ACCOUNT, selectedAccountId);
    }
  }, [selectedAccountId]);

  if (accountDropdownItems && accountDropdownItems.length === 1) {
    return (
      <SingleAccountContainer data-testid="SingleAccountContainer">
        {accountDropdownItems[0].name}
      </SingleAccountContainer>
    );
  }

  return (
    <AccountPickerContainer data-testid="AccountPickerContainer">
      <KatDropdown
        size="small"
        value={selectedAccountId}
        options={accountDropdownItems}
        onChange={(e: KatDropdown.ChangeEvent) => {
          setSelectedAccountId(e.detail.value);
        }}
      />
    </AccountPickerContainer>
  );
};
export default AccountPicker;
